<template>
  <div class="overflow-y-auto max-h-full pr-4 -mr-4">
    <Question
      v-for="question in questions"
      :key="question.id"
      :question="question"
    />

    <p
      v-if="questions.length === 0"
      class="text-md14-h18 text-base-30 text-center mt-8"
    >
      <template v-if="selectedStatus === 'pending'">
        There are currently no questions to review.
      </template>
      <template v-if="selectedStatus === 'approved'">
        You haven’t approved any questions yet.
      </template>
      <template v-if="selectedStatus === 'dismissed'">
        You haven’t dismissed any questions yet.
      </template>
    </p>
  </div>
</template>

<script>
import Question from '@/components/question-moderation/Question.vue'

// containers
import QuestionContainer from '@/containers/question-moderation/Question.ts'

export default {
  components: {
    Question: QuestionContainer(Question),
  },
  props: {
    selectedStatus: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
}
</script>
